
// Module
import routes from './routes';

export default angular.module('app.main.appNotificationClick.module', [])
	.config(routes)
	.name


/** WEBPACK FOOTER **
 ** ./src/main/appNotificationClick/index.js
 **/